import ComponentBasePrototype from 'ComponentBasePrototype';
import $ from 'jquery';

export default class NewMagnoliaCard extends ComponentBasePrototype {
  build() {
    this.setComponentOrientation();
    this.updateComponentOrientationOnResize();
    this.handleCardClick();
  }

  setComponentOrientation() {
    if (this.isHorizontal()) {
      this.node.addClass('cms-new-magnolia-card--horizontal');
    } else {
      this.node.removeClass('cms-new-magnolia-card--horizontal');
    }
  }

  updateComponentOrientationOnResize() {
    $(window).on('resize', () => {
      this.setComponentOrientation();
    });
  }

  isHorizontal() {
    const cardWidth = this.node.width();
    const windowWidth = window.innerWidth;

    return cardWidth / windowWidth > 0.8;
  }
  handleCardClick() {
    $('.cms-new-magnolia-card__link-overlay').on('click', function () {
      const url = $(this).data('href');
      const openInNewTab = $(this).data('open-in-new-tab') === true; // Jquery converts the string true or false to a boolean
      if (url) {
        if (openInNewTab) {
          // Open the link in a new tab
          window.open(url, '_blank');
        } else {
          // Navigate to the link in the current tab
          window.location.href = url;
        }
      }
    });
  }

}
